<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <v-card>
      <v-card-title class="text-h5">
        {{ title }}
      </v-card-title>
      <v-card-text>
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="type === 'confirm'"
          color="grey-darken-1"
          variant="text"
          @click="handleCancel"
        >
          キャンセル
        </v-btn>
        <v-btn color="primary" variant="text" @click="handleConfirm">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useDialogStore } from "@/store/dialog";

const dialogStore = useDialogStore();

const dialog = ref(false);
const title = ref("");
const message = ref("");
const type = ref<"alert" | "confirm">("alert");

// ストアの状態を監視してダイアログを表示
watch(
  () => dialogStore.isOpen,
  (newValue) => {
    dialog.value = newValue;
    if (newValue) {
      title.value = dialogStore.title;
      message.value = dialogStore.message;
      type.value = dialogStore.type;
    }
  }
);

function handleConfirm() {
  dialogStore.confirm();
}

function handleCancel() {
  dialogStore.cancel();
}
</script>
